import { AiEngineDataType } from "./enums";

export const AiEnginePaths = {
  [AiEngineDataType.HomeRecommendedForYou]: "/recommend/home",
  [AiEngineDataType.HomeYouMayHaveMissed]: "/recommend/may-have-missed",
  [AiEngineDataType.MoreOnThisTopic]: "/recommend/next",
  [AiEngineDataType.MyNewsFresh]: "/recommend/my-news/fresh",
  [AiEngineDataType.MyNewsHot]: "/recommend/my-news/hot",
  [AiEngineDataType.OnBoard]: "/recommend/on-board",
  [AiEngineDataType.Section]: "/recommend/section",
};

export const AiFallbackPaths = {
  [AiEngineDataType.HomeRecommendedForYou]: "/rec-backup/home.json",
  [AiEngineDataType.HomeYouMayHaveMissed]: "/rec-backup/may-have-missed.json",
  [AiEngineDataType.MoreOnThisTopic]: "/rec-backup/next.json",
  [AiEngineDataType.MyNewsFresh]: "/rec-backup/my-news/fresh.json",
  [AiEngineDataType.MyNewsHot]: "/recommend/my-news/hot.json",
  [AiEngineDataType.OnBoard]: "/rec-backup/on-board",
  [AiEngineDataType.Section]: "/rec-backup/section.json",
};
